import { isArray } from 'util';
import { Refrigeration } from '../refrigeration';

export class RefrigerationBuilder {
  static fromJson(json) {
    return (json)
      ? new Refrigeration(
        json.hash,
        json.name,
        json.value
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(RefrigerationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/refrigeration.builder.ts